export const BUSINESS_TYPES = [
    "Advertiser",
    "Agency",
    "SEM Manager/Analyst",
    "Affiliate Marketer",
    "Publisher/Ad Network/DSP"
] as const;

export const AD_BUDGET_TYPES = [
    "Less than $25K",
    "$25K-$50K",
    "$50K-$100K",
    "$100K-$200K",
    "$200K and above",
] as const;

export const DECISION_TYPES = [
    "0-3 Months",
    "3-6 Months",
    "Sometime this year",
] as const;

export default class BusinessType {

    public static getAll(): { [key: string]: string } {
        const businessTypes: { [key: string]: string } = {};
        businessTypes[""] = "What's your Business Type?";
        for (const type of BUSINESS_TYPES) {
            businessTypes[type] = type;
        }
        return businessTypes;
    }

    public static getAllAdBudgets(): { [key: string]: string } {
        const adBudgets: { [key: string]: string } = {};
        adBudgets[""] = "What's your Monthly Ad Budget?";
        for (const type of AD_BUDGET_TYPES) {
            adBudgets[type] = type;
        }
        return adBudgets;
    }

}